import { API, METHODS } from "../../../shared/constants";
import { request } from "../../../shared/utils";

export default {
  getProtocols: () => request(METHODS.GET, API.PROTOCOL.GET_PROTOCOLS)(),
};
